import { ReactNode, useState, useEffect } from 'react'
import {
  IoFlashSharp,
  // IoHeartSharp,
  IoLeafSharp,
  // IoSparklesSharp,
  // IoStatsChartSharp,
} from 'react-icons/io5'
import cn from 'classnames'

import { Link } from 'react-router-dom'

import { getBackend } from '../../lib/icp'

import { Button } from '../../components'
import { useTranslation, useUser } from '../../hooks'
import { SortBy, TimeRange } from './enums'

import pages, { generateUrl } from '../../pages'

import styles from './Sorting.module.scss'

const SORT_LIST = Object.values(SortBy)

const TIME_RANGE_LIST = Object.values(TimeRange)

const SORT_ICONS = {
  // [SortBy.Recommended]: IoSparklesSharp,
  [SortBy.Hot]: IoFlashSharp,
  // [SortBy.MostViewed]: IoStatsChartSharp,
  // [SortBy.TopRated]: IoHeartSharp,
  [SortBy.Newest]: IoLeafSharp,
}

interface SortingProps {
  sortBy: SortBy
  timeRange: TimeRange
  onChange: (sortBy: SortBy, timeRange: TimeRange) => void
}

const List = ({ children }: { children: ReactNode }) => (
  <div className={styles.list}>{children}</div>
)

const renderIcon = (sortBy: SortBy) => {
  const IconComponent = SORT_ICONS[sortBy]
  return <IconComponent />
}

const Sorting = ({ onChange, sortBy, timeRange }: SortingProps) => {
  const { loggedIn } = useUser()
  const [isSubs, setIsSubs] = useState<boolean>(false)
  const { t } = useTranslation()
  const { pathname, search } = window.location
  const [focusUser, setFocusUser] = useState<any>([])

  // useEffect(() => {
  //   if (pathname === '/' && search === '?s=recommended&t=weekly') {
  //     setIsSubs(true)
  //   } else {
  //     setIsSubs(false)
  //   }
  // }, [search])

  // 获取关注列表
  const get_information = async () => {
    // const backend = await getBackend()
    // const user_list = await backend.getSubscriptionsUser()
    // setFocusUser(user_list)
  }
  return (
    <div className={styles.container}>
      {/* 正常首页 */}
      {!isSubs && (
        <ul className={styles.sort_head}>
          {SORT_LIST.map((sortById) => {
            return (
              <li
                key={sortById}
                className={sortById === sortBy ? styles.head_selected : ''}
                onClick={() => onChange(sortById, timeRange)}
              >
                {t(`sorting_${sortById}`)}
              </li>
            )
          })}
        </ul>
      )}
      {!isSubs && (
        <ul className={styles.sort_times}>
          {TIME_RANGE_LIST.map((timeRangeId) => (
            <li
              key={timeRangeId}
              className={timeRangeId === timeRange ? styles.time_selected : ''}
              onClick={() => onChange(sortBy, timeRangeId)}
            >
              {t(`sorting_${timeRangeId}`)}
            </li>
          ))}
        </ul>
      )}
      {/* Your subscriptions */}
      {isSubs && (
        <div className={styles.subscriptions_wrap}>
          {focusUser && focusUser.length > 0 && (
            <h1 className={styles.subscriptions_title}>Your subscriptions</h1>
          )}
          <div className={styles.subscriptions_content}>
            <div className={styles.subscriptions_content_left}>
              {focusUser &&
                focusUser.length > 0 &&
                focusUser.map((item: any) => {
                  return (
                    <ul className={styles.subscriptions_content_left_ul}>
                      <li className={styles.subscriptions_content_left_ul_img}>
                        <Link
                          to={generateUrl(pages.channel.path, {
                            userName: item.userName,
                          })}
                        >
                          <img src={item.imgUrl} alt="" />
                        </Link>
                      </li>
                      <li className={styles.subscriptions_content_left_ul_name}>
                        {item.userName}
                      </li>
                      <li
                        className={styles.subscriptions_content_left_ul_hover}
                      ></li>
                    </ul>
                  )
                })}
            </div>
            <div className={styles.subscriptions_content_right}>
              Manage Subs
            </div>
          </div>
        </div>
      )}
    </div>

    // <div className={styles.container}>
    //   <List>
    //     {SORT_LIST.map((sortById) =>
    //       sortById !== SortBy.Recommended || loggedIn ? (
    //         <Button
    //           key={sortById}
    //           className={cn(styles.sortByButton, {
    //             [styles.selected]: sortById === sortBy,
    //           })}
    //           small
    //           onClick={() => onChange(sortById, timeRange)}
    //           icon={renderIcon(sortById)}
    //         >
    //           {t(`sorting_${sortById}`)}
    //         </Button>
    //       ) : null,
    //     )}
    //   </List>

    //   {sortBy !== SortBy.Newest && sortBy !== SortBy.Recommended && (
    //     <List>
    //       {TIME_RANGE_LIST.map((timeRangeId) => (
    //         <Button
    //           key={timeRangeId}
    //           className={cn(styles.timeRangeButton, {
    //             [styles.selected]: timeRangeId === timeRange,
    //           })}
    //           small
    //           onClick={() => onChange(sortBy, timeRangeId)}
    //         >
    //           {t(`sorting_${timeRangeId}`)}
    //         </Button>
    //       ))}
    //     </List>
    //   )}
    // </div>
  )
}

export default Sorting
